import React from 'react';

import { cn } from '@/lib/utils';

export interface ActivityTimestampProps {
  timestamp: Date | string;
  className?: string;
}

export const ActivityTimestamp: React.FC<ActivityTimestampProps> = ({
  timestamp,
  className,
}) => {
  const displayTime =
    typeof timestamp === 'string' ? timestamp : formatRelativeTime(timestamp);

  return (
    <span className={cn('text-sm text-gray-500', className)}>
      {displayTime}
    </span>
  );
};

function formatRelativeTime(date: Date): string {
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return '1d ago';
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)}mo ago`;
  return `${Math.floor(diffDays / 365)}y ago`;
}
